import { getOrderPassengerPoints } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model): string => {
	const points = getOrderPassengerPoints(item) ?? [];
	const lastPoint = points.at(-1);
	return lastPoint?.settlement ?? "";
};

export default cellProcessing;
